import { render } from "./InsuranceRateCards.vue?vue&type=template&id=595c4381&scoped=true"
import script from "./InsuranceRateCards.vue?vue&type=script&lang=js"
export * from "./InsuranceRateCards.vue?vue&type=script&lang=js"

import "./InsuranceRateCards.vue?vue&type=style&index=0&id=595c4381&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595c4381"]])

export default __exports__